import moment from 'moment'
import { message } from 'ant-design-vue'
import store from '@/store'
import { computed } from 'vue'
import Config from '@/config/index'
import head_z from '@/assets/img/chat/head_z.png'
import head_d from '@/assets/img/chat/head_d.png'
import head_a from '@/assets/img/chat/head_a.png'
import head_p from '@/assets/img/chat/head_p.png'
import head_h from '@/assets/img/chat/head_h.png'
import head_ai from '@/assets/img/chat/head_ai.png'
// 今日的聊天：展示“时分”
// 昨日的聊天：展示“昨天  时分”
// 昨天之前，本周的聊天：展示：“周几 时分”
// 昨天之前，本年内的聊天：展示“月日时分”
// 往年的，展示“年月日时分”
export function formatTime(time) {
  if (!time) return ''
  const momentDate = moment(parseInt(time))
  const REFERENCE = moment() // fixed just for testing, use moment();
  const TODAY = REFERENCE.clone().startOf('day')
  const YESTERDAY = REFERENCE.clone().subtract(1, 'days').startOf('day')
  const WEEKOFDAY = parseInt(REFERENCE.format('day')) // 计算今天是这周第几天 周日为一周中的第一天
  const start = moment()
    .subtract(WEEKOFDAY - 1, 'days')
    .format('YYYY-MM-DD') // 周一日期
  const end = moment()
    .add(7 - WEEKOFDAY, 'days')
    .format('YYYY-MM-DD') // 周日日期

  //判断是否是今天
  const isToday = momentDate.isSame(TODAY, 'day')
  //判断是否是昨天
  const isYesterday = momentDate.isSame(YESTERDAY, 'day')
  //判断是否是本周
  const isWithinAWeek = momentDate.isBetween(start, end)
  //判断是否是今年
  const isThisYear = momentDate.isSame(REFERENCE, 'year')

  if (isToday) {
    return momentDate.format('HH:mm')
  } else if (isYesterday) {
    return '昨天 ' + momentDate.format('HH:mm')
  } else if (isWithinAWeek) {
    const week = ['一', '二', '三', '四', '五', '六', '日']
    return `周${week[momentDate.format('E') - 1]} ` + momentDate.format('HH:mm')
  } else if (isThisYear) {
    return momentDate.format('MM-DD HH:mm')
  } else {
    return momentDate.format('YY-MM-DD HH:mm')
  }
}
// https转换
export function httpFilter(val = '') {
  return val.replace('http://', 'https://')
}
/**
 * Parse the time to string
 * @param {(Object|string|number)} time
 * @param {string} cFormat
 * @returns {string | null}
 */
export function parseTime(time, cFormat) {
  if (arguments.length === 0 || !time) {
    return null
  }
  const format = cFormat || '{y}-{m}-{d} {h}:{i}:{s}'
  let date
  if (typeof time === 'object') {
    date = time
  } else {
    if (typeof time === 'string') {
      if (/^[0-9]+$/.test(time)) {
        // support "1548221490638"
        time = parseInt(time)
      } else {
        // support safari
        // https://stackoverflow.com/questions/4310953/invalid-date-in-safari
        time = time.replace(new RegExp(/-/gm), '/')
      }
    }

    if (typeof time === 'number' && time.toString().length === 10) {
      time = time * 1000
    }
    date = new Date(time)
  }
  const formatObj = {
    y: date.getFullYear(),
    m: date.getMonth() + 1,
    d: date.getDate(),
    h: date.getHours(),
    i: date.getMinutes(),
    s: date.getSeconds(),
    a: date.getDay()
  }
  const time_str = format.replace(/{([ymdhisa])+}/g, (result, key) => {
    const value = formatObj[key]
    // Note: getDay() returns 0 on Sunday
    if (key === 'a') {
      return ['日', '一', '二', '三', '四', '五', '六'][value]
    }
    return value.toString().padStart(2, '0')
  })
  return time_str
}

/**
 * @param {string} url
 * @returns {Object}
 */
export function getQueryObject(url) {
  url = url == null ? window.location.href : url
  const search = url.substring(url.lastIndexOf('?') + 1)
  const obj = {}
  const reg = /([^?&=]+)=([^?&=]*)/g
  search.replace(reg, (rs, $1, $2) => {
    const name = decodeURIComponent($1)
    let val = decodeURIComponent($2)
    val = String(val)
    obj[name] = val
    return rs
  })
  return obj
}

/**
 * @param {string} input value
 * @returns {number} output value
 */
export function byteLength(str) {
  // returns the byte length of an utf8 string
  let s = str.length
  for (var i = str.length - 1; i >= 0; i--) {
    const code = str.charCodeAt(i)
    if (code > 0x7f && code <= 0x7ff) s++
    else if (code > 0x7ff && code <= 0xffff) s += 2
    if (code >= 0xdc00 && code <= 0xdfff) i--
  }
  return s
}

/**
 * @param {Array} actual
 * @returns {Array}
 */
export function cleanArray(actual) {
  const newArray = []
  for (let i = 0; i < actual.length; i++) {
    if (actual[i]) {
      newArray.push(actual[i])
    }
  }
  return newArray
}

/**
 * @param {Object} json
 * @returns {Array}
 */
export function param(json) {
  if (!json) return ''
  return cleanArray(
    Object.keys(json).map(key => {
      if (json[key] === undefined) return ''
      return encodeURIComponent(key) + '=' + encodeURIComponent(json[key])
    })
  ).join('&')
}

/**
 * @param {string} url
 * @returns {Object}
 */
export function param2Obj(url) {
  const search = decodeURIComponent(url.split('?')[1]).replace(/\+/g, ' ')
  if (!search) {
    return {}
  }
  const obj = {}
  const searchArr = search.split('&')
  searchArr.forEach(v => {
    const index = v.indexOf('=')
    if (index !== -1) {
      const name = v.substring(0, index)
      const val = v.substring(index + 1, v.length)
      obj[name] = val
    }
  })
  return obj
}

/**
 * @param {string} val
 * @returns {string}
 */
export function html2Text(val) {
  const div = document.createElement('div')
  div.innerHTML = val
  return div.textContent || div.innerText
}

/**
 * Merges two objects, giving the last one precedence
 * @param {Object} target
 * @param {(Object|Array)} source
 * @returns {Object}
 */
export function objectMerge(target, source) {
  if (typeof target !== 'object') {
    target = {}
  }
  if (Array.isArray(source)) {
    return source.slice()
  }
  Object.keys(source).forEach(property => {
    const sourceProperty = source[property]
    if (typeof sourceProperty === 'object') {
      target[property] = objectMerge(target[property], sourceProperty)
    } else {
      target[property] = sourceProperty
    }
  })
  return target
}

/**
 * @param {HTMLElement} element
 * @param {string} className
 */
export function toggleClass(element, className) {
  if (!element || !className) {
    return
  }
  let classString = element.className
  const nameIndex = classString.indexOf(className)
  if (nameIndex === -1) {
    classString += '' + className
  } else {
    classString =
      classString.substr(0, nameIndex) + classString.substr(nameIndex + className.length)
  }
  element.className = classString
}

/**
 * @param {string} type
 * @returns {Date}
 */
export function getTime(type) {
  if (type === 'start') {
    return new Date().getTime() - 3600 * 1000 * 24 * 90
  } else {
    return new Date(new Date().toDateString())
  }
}

/**
 * @param {Function} func
 * @param {number} wait
 * @param {boolean} immediate
 * @return {*}
 */
export function debounce(func, wait = 300, immediate = false) {
  let timeout, args, context, timestamp, result
  const later = function () {
    // 据上一次触发时间间隔
    const last = +new Date() - timestamp
    // 上次被包装函数被调用时间间隔 last 小于设定时间间隔 wait
    if (last < wait && last > 0) {
      timeout = setTimeout(later, wait - last)
    } else {
      timeout = null
      // 如果设定为immediate===true，因为开始边界已经调用过了此处无需调用
      if (!immediate) {
        result = func.apply(context, args)
        if (!timeout) context = args = null
      }
    }
  }

  return function (..._args) {
    args = _args
    context = this
    timestamp = +new Date()
    const callNow = immediate && !timeout
    // 如果延时不存在，重新设定延时
    if (!timeout) timeout = setTimeout(later, wait)
    if (callNow) {
      result = func.apply(context, args)
      context = args = null
    }
    return result
  }
}

/**
 * This is just a simple version of deep copy
 * Has a lot of edge cases bug
 * If you want to use a perfect deep copy, use lodash's _.cloneDeep
 * @param {Object} source
 * @returns {Object}
 */
export function deepClone(source) {
  if (!source && typeof source !== 'object') {
    throw new Error('error arguments', 'deepClone')
  }
  const targetObj = source.constructor === Array ? [] : {}
  Object.keys(source).forEach(keys => {
    if (source[keys] && typeof source[keys] === 'object') {
      targetObj[keys] = deepClone(source[keys])
    } else {
      targetObj[keys] = source[keys]
    }
  })
  return targetObj
}

/**
 * @param {Array} arr
 * @returns {Array}
 */
export function uniqueArr(arr) {
  return Array.from(new Set(arr))
}

/**
 * @returns {string}
 */
export function createUniqueString() {
  const timestamp = +new Date() + ''
  const randomNum = parseInt((1 + Math.random()) * 65536) + ''
  return (+(randomNum + timestamp)).toString(32)
}

/**
 * Check if an element has a class
 * @param {HTMLElement} elm
 * @param {string} cls
 * @returns {boolean}
 */
export function hasClass(ele, cls) {
  return !!ele.className.match(new RegExp('(\\s|^)' + cls + '(\\s|$)'))
}

/**
 * Add class to element
 * @param {HTMLElement} elm
 * @param {string} cls
 */
export function addClass(ele, cls) {
  if (!hasClass(ele, cls)) ele.className += ' ' + cls
}

/**
 * Remove class from element
 * @param {HTMLElement} elm
 * @param {string} cls
 */
export function removeClass(ele, cls) {
  if (hasClass(ele, cls)) {
    const reg = new RegExp('(\\s|^)' + cls + '(\\s|$)')
    ele.className = ele.className.replace(reg, ' ')
  }
}

// 获取user_agent
export function getBrowserInfo() {
  var Sys = {}
  var ua = navigator.userAgent.toLowerCase()
  var re = /(msie|firefox|chrome|opera|version).*?([\d.]+)/
  var m = ua.match(re)
  try {
    Sys.browser = m[1].replace(/version/, "'safari")
    Sys.ver = m[2]
  } catch (e) {
    console.log('getBrowserInfo fail.')
  }
  const { browser, ver } = Sys
  const userAgent = browser && ver ? `${browser}/${ver}` : ''
  return userAgent
}

export function subStringToType(str = '') {
  // R:线上处方  H:健康辅助方  HR:线下处方
  if (str.substring(0, 2) == 'HR') {
    return 'prescriptionOffline'
  } else {
    const n = str.substring(0, 1)
    if (n == 'H') {
      return 'prescriptionHealth'
    } else if (n == 'R') {
      return 'prescriptionOnline'
    } else {
      return 'prescriptionGroup'
    }
  }
}

export function filterEmoij(text = '') {
  const emojiAll = new RegExp(`([\\ud83c-\\ud83f])([\\udc00-\\udfff])`)
  return text.replace(emojiAll, '')
}

/**
 * 适配历史数据的诊断显示字段
 * @param row 当前数据集合 {}
 * @param k1  优先级高的显示字段 []
 * @param k2  低优先级显示字段 [] | ''
 */
export function calcDiagnosis(row, k1, k2) {
  if (!row) return
  try {
    const temp1 = (row[k1] || [])
      .map(e => {
        return e.diagnosisName + (e.remark ? '【' + e.remark + '】' : '')
      })
      .join('；')
    const temp2 = row[k2] instanceof Array ? row[k2].map(e => e).join('；') : row[k2]
    return row[k1] && row[k1].length ? temp1 : temp2 || '--'
  } catch (error) {
    console.log('==>', error, row, row[k1], row[k2])
  }
}

export function newCalcDiagnosis(row, k) {
  if (!row) return '--'
  const temp = row[k] instanceof Array ? row[k].map(e => e.diagnosisName).join('；') : row[k]
  return temp
}

//数组去除空数据
export function trimSpace(array) {
  if (!Array.isArray(array)) return []
  for (let i = 0; i < array.length; i++) {
    if (array[i] == '' || array[i] == null || typeof array[i] == 'undefined') {
      array.splice(i, 1)
      i = i - 1
    }
  }
  return array
}
// 时间只展示到日期，不展示具体的时间
export function filterTime({ text }) {
  return text ? moment(text).format('YYYY-MM-DD') : ''
}
// 限制输入框输入表情
export function filterInput(e) {
  //特殊表情符号
  let value = e.replace(
    new RegExp(
      // eslint-disable-next-line no-control-regex
      '[^\u0020-\u007E\u00A0-\u00BE\u2E80-\uA4CF\uF900-\uFAFF\uFE30-\uFE4F\uFF00-\uFFEF\u0080-\u009F\u2000-\u201f\u2026\u2022\u20ac\r\n]',
      'gm'
    ),
    ''
  )
  //空格
  value = value.replace(/\s+/g, '')
  return value
}
// 治疗状态字典 -1 不展示 0-未判定 2-治愈 3-失访 4-无效 5-有效")
const cureStatusList = ['待判定', '', '治愈', '失访', '无效', '有效']
export function handleCureStatus(text) {
  return cureStatusList[text] || '--'
}
export function handleAssertCureName(text) {
  return text ? '健管-' + text : '--'
}
// 随访推送状态
export function handleFlowStatus(text) {
  const status = ['待推送', '已推送', '取消推送', '不推送']
  return status[text] || '--'
}
// 复制
export function handleCopy(val) {
  const input = document.createElement('input')
  document.body.appendChild(input)
  input.setAttribute('value', val)
  input.select()
  if (document.execCommand('copy')) {
    document.execCommand('copy')
    message.success('复制成功')
  }
  document.body.removeChild(input)
}
const emptyVal = [undefined, null]
// 处理金额展示问题
export function handlePrice(val, flag = true) {
  // flag 为true，要精确到分
  if (flag && val === 0) {
    return '0.00元'
  } else if (emptyVal.includes(val)) {
    return '--'
  }
  return val + '元'
}
export function momentFormat(d, mode = 'YYYY-MM-DD') {
  if (!d) return '--'
  return moment(d).format(mode)
}

//树结果快速查询符合条件节点
export function findNode(tree, childKey, func) {
  for (const node of tree) {
    if (func(node)) return node
    if (node[childKey]) {
      const res = findNode(node[childKey], childKey, func)
      if (res) return res
    }
  }
  return null
}
// 关键字高亮展示
export function brightenKeyword(record) {
  const { workOrderTask, serialNumber, businessType, reserveSn, workOrderType, follUpPlanId } =
    record
  let keyword = ''
  if (businessType === 7 || workOrderType === 7) {
    keyword = reserveSn
  } else if (businessType === 11 || businessType === 12) {
    keyword = follUpPlanId
  } else {
    keyword = serialNumber
  }
  if (!workOrderTask) return '--'
  const Reg = new RegExp(keyword, 'i')
  if (keyword) {
    return workOrderTask.replace(
      Reg,
      `<span style="color: #1890FF;cursor:pointer">${keyword}</span>`
    )
  }
  return workOrderTask
}
export function getHourAndMinute(date) {
  if (!date) return ''
  return moment(date).format('HH:mm')
}
export function getYearAndMonth(date) {
  if (!date) return ''
  return moment(date).format('YYYY-MM')
}
export function getDay(date) {
  if (!date) return ''
  return moment(date).format('DD')
}
export function handleGaugeSource(soure) {
  if (soure === null) return '--'
  return ['随访计划', '导诊咨询'][soure]
}
// 门诊病历上传人逻辑处理
export function calcUpload(record, key) {
  // const { createId, uploaderId, createType, uploaderType } = record
  return record[key]
  // if (key === 'createBy') {
  //   return createId === ucUserId.value && createType === 4 ? '本人' : record[key]
  // } else {
  //   return uploaderId === ucUserId.value && uploaderType === 4 ? '本人' : record[key]
  // }
}
// 群聊中区分角色 0-患者，1-bd,2-健管，3-医生 4-医生学生 6-ai
export function handleRole(id) {
  if (id === 'aiassistantadmin') return 5
  if (id === 'aiassistant') return 6
  if (RegExp(Config.SYSTEM_SOLE).test(id)) return 2
  if (!id) return 2
  let role = 3
  switch (id.substr(0, 1)) {
    case 'p':
      role = 0
      break
    case 'a':
      role = 1
      break
    case 'z':
      role = 2
      break
    case 'h':
      role = 4
      break
    default:
      break
  }
  return role
}
// 用来区分
export function handleMsgRole(id) {
  return handleRole(id)
}
//判断展示职称样式
export const renderClass = id => {
  if (RegExp(Config.SYSTEM_SOLE).test(id)) return { backgroundColor: '#EAEAEA', color: '#8C8C8C' }
  const role = handleRole(id)
  const arr = [
    { backgroundColor: '#FFEED9', color: '#FFA940' },
    { backgroundColor: '#D3F2EC', color: '#24BCA2' },
    { backgroundColor: '#F9F0FF', color: '#722ED1' },
    { backgroundColor: '#D6EAFF', color: '#1890FF' },
    { backgroundColor: '#D6EAFF', color: '#1890FF' }
  ]
  return arr[role]
}
//判断展示名称
export const renderTitle = id => {
  if (id === 'aiassistantadmin') return ''
  if (RegExp(Config.SYSTEM_SOLE).test(id)) return '医生助手'
  const role = handleRole(id)
  const arr = ['患者', '医生助手', '健管', '医生', '医生学生']
  return arr[role]
}
//判断展示用户姓名
export const renderName = (id, ext = {}) => {
  const { showErp = false, groupInfo = {} } = ext
  if (id === 'aiassistantadmin') return '智能医助'
  if (id === 'aiassistant') return '智能医助'
  if (RegExp(Config.SYSTEM_SOLE).test(id)) return '系统'
  const curPrivateMembers = computed(() => store.state.workOrder.privateGroupMembers)
  const {
    assistantInfos = [],
    doctorAssistantInfos = [],
    doctorInfo = {},
    patientInfo = {},
    doctorHelperInfos = []
  } = groupInfo
  //健康管家/BD
  const aUserName = (
    (assistantInfos &&
      assistantInfos.concat(curPrivateMembers.value).find(item => item.userId === id)) ||
    {}
  ).username
  //医生助手
  const targetDoctoreAss =
    (doctorAssistantInfos &&
      doctorAssistantInfos.concat(curPrivateMembers.value).find(item => item.userId === id)) ||
    {}
  const zUserName = showErp
    ? targetDoctoreAss.username && targetDoctoreAss.erpId
      ? targetDoctoreAss.username + ' ' + targetDoctoreAss.erpId
      : ''
    : targetDoctoreAss.username
  const hUserName = (
    (doctorHelperInfos &&
      doctorHelperInfos.concat(curPrivateMembers.value).find(item => item.userId === id)) ||
    {}
  ).username
  const role = handleRole(id)
  const arr = [patientInfo.username, aUserName, zUserName, doctorInfo?.username || '', hUserName]
  return arr[role]
}
//判断展示头像
export const renderHeader = param => {
  const { id, groupInfo = {} } = param
  const { assistantInfos = {}, doctorInfo = {}, patientInfo = {} } = groupInfo
  const role = handleRole(id)
  const arr = [
    patientInfo.headUrl || head_p,
    assistantInfos.headUrl || head_a,
    head_z,
    doctorInfo.headUrl || head_d,
    head_h,
    head_z,
    head_ai
  ]
  return arr[role]
}
//时间转换
export const renderTime = (x = 0) => {
  const d = moment.duration(x, 'seconds')
  if (x < 60) return d.seconds() + '秒'
  if (x < 3600) return d.minutes() + '分' + d.seconds() + '秒'
  return d.hours() + '时' + d.minutes() + '分' + d.seconds() + '秒'
}

export const showWorkOrderBtn = record => {
  const { callerType, calleeType, workOrderIds } = record
  return workOrderIds?.length && (callerType === 4 || calleeType === 4)
}
// 处理开始时间和结束时间的筛选条件,format 为true表示精确到日，否则精确到秒
export const formatDateForFilter = (dateList = [], format) => {
  const startDate = dateList[0] || ''
  const endDate = dateList[1] || ''
  if (format) {
    return [
      startDate ? moment(startDate).format('YYYY-MM-DD') : null,
      endDate ? moment(endDate).format('YYYY-MM-DD') : null
    ]
  } else {
    return [
      startDate ? moment(startDate).format('YYYY-MM-DD') + ' 00:00:00' : null,
      endDate ? moment(endDate).format('YYYY-MM-DD') + ' 23:59:59' : null
    ]
  }
}
const visitTypeMap = ['平台', '临观', '医生']
export const handlePlanType = text => {
  return visitTypeMap[text] || '--'
}
// 根据月份转化成具体日期
export const formateDateByMonth = (start, end) => {
  const start1 = start ? moment(start).startOf('month').format('YYYY-MM-DD') + ' 00:00:00' : null
  const end1 = end ? moment(end).endOf('month').format('YYYY-MM-DD') + ' 23:59:59' : null
  return [start1, end1]
}

// 处理嘱托
/**
 *
 * 获取嘱托
 * @param {taboo} 使用禁忌数据参数
 * @param {advice} 医嘱数据参数
 *
 */
export const getEntrust = (taboo, advice) => {
  if (!taboo && !advice) return '无'
  if (!advice || advice === '无') return taboo
  return `${taboo}；${advice}`
}

// 展示是用药说明还是嘱托
export const getTitle = usage => {
  const { mode = '' } = usage || {}
  const title = '嘱托'
  const titleOther = '用药说明'
  if (mode === '外敷' || mode === '外用') {
    return titleOther
  } else {
    return title
  }
}
// 群聊图片转码处理
export const handleImg = url => {
  const arr = url.split('?')
  if (arr[1]) {
    const newUrl = arr[0] + encodeURIComponent('?' + arr[1])
    return newUrl
  } else {
    return url
  }
}

// 根据群聊或私聊区分群成员
export const handleGroupMembers = chatType => {
  const curGroupInfo = computed(() => store.state.workOrder.workOrderGroupInfo)
  const curPrivateMembers = computed(() => store.state.workOrder.privateGroupMembers)
  // 在群成员和排除医生学生账号
  const filterOPtions = its => {
    return its.deleteFlag !== true && its.identityType !== 8
  }
  const { assistantInfos, doctorInfo, patientInfo, doctorAssistantInfos } = curGroupInfo.value
  let MembersIds = []
  if (chatType === 'guide') {
    MembersIds = [patientInfo, ...doctorAssistantInfos].filter(filterOPtions).map(item => {
      return item.userId
    })
  } else if (chatType === 'public') {
    const members = [...assistantInfos, doctorInfo, patientInfo, ...doctorAssistantInfos]
    console.log('members', members)
    MembersIds = members.filter(filterOPtions).map(item => {
      return item.userId
    })
  } else {
    MembersIds = curPrivateMembers.value.filter(filterOPtions).map(item => {
      return item.userId
    })
  }
  console.log('【当前群成员】', MembersIds)
  return MembersIds.filter(it => it)
}

export function isWithinLast24Hours(timestamp) {
  const oneDay = 24 * 60 * 60 * 1000 // 1天的毫秒数
  const now = new Date().getTime() // 当前时间的时间戳
  return now - timestamp < oneDay
}

export function secondsToHhMmSs(seconds) {
  let hours = Math.floor(seconds / 3600)
  let minutes = Math.floor((seconds % 3600) / 60)
  let secs = seconds % 60
  hours = hours < 10 ? '0' + hours : hours
  minutes = minutes < 10 ? '0' + minutes : minutes
  secs = secs < 10 ? '0' + secs : secs
  return hours + ':' + minutes + ':' + secs
}
export function concatEditor(role, name) {
  if (role && name) {
    return `${role}-${name}`
  } else {
    return role || name
  }
}
const FORMAT = {
  1: 'YYYY-MM-DD',
  2: 'YYYY-MM-DD HH:mm',
  3: 'YYYY-MM-DD HH:mm:ss'
}
export function formatDate(time, mode = 1) {
  if (!time) return ''
  const formateMode = FORMAT[mode] || FORMAT[1]
  return moment(time).format(formateMode)
}

// 两个时间判断差了多少秒
export function getDiffSeconds(time) {
  const now = new Date().getTime()
  const target = new Date(time).getTime()
  return Math.abs(now - target) / 1000
}

// 格式化数据：处理整数和小数
export const handleFormatNumber = num => {
  // 处理空值
  if (num === null || num === undefined || Number.isNaN(Number(num))) {
    return '--'
  }
  const number = Number(num)
  return Number.isInteger(number) ? number.toString() : number.toFixed(2)
}

const weekDays = {
  0: '周日',
  1: '周一',
  2: '周二',
  3: '周三',
  4: '周四',
  5: '周五',
  6: '周六'
}
export function handleTimeShowWeek(time, type = '') {
  if (!time) return ''
  // 处理多种中文格式日期
  const chineseFormats = [
    'YYYY年MM月DD日 HH:mm:ss',
    'YYYY年MM月DD日 HH时mm分ss秒',
    'YYYY年MM月DD日'
  ]
  // 判断是否为中文格式
  const isChineseDate = /[\u4e00-\u9fa5]/.test(time)
  let standardizedDate
  // 解析日期
  if (isChineseDate) {
    // 尝试多种中文格式
    standardizedDate = moment(time, chineseFormats, true)
  } else {
    standardizedDate = moment(time)
  }
  // 检查是否为有效日期
  if (!standardizedDate.isValid()) return ''
  const dayIndex = standardizedDate.day()
  const weekDay = weekDays[dayIndex]
  const formattedTime = type ? standardizedDate.format(type) : time
  return `${formattedTime} ${weekDay} `
}

// 将金额从 分 转换为 元 单位
export function formatAmount(num) {
  // 处理空值
  if (num === null || num === undefined) return '--'

  // 将金额从 分 转换成 元
  const amount = num / 100
  // 小数部分
  const decimalPart = amount.toString().split('.')[1] || ''
  // 根据小数位数决定显示格式
  return amount.toFixed(decimalPart.length > 1 ? 2 : decimalPart.length)
}

// 判断数据是否为空包括空字符串、null、undefined、NaN、0、false
export const isEmpty = value => {
  if (value === null || value === undefined || !value) return true
  if (
    (typeof value === 'string' && value.trim() === '') ||
    value.trim() === 'null' ||
    value.trim() === 'undefined'
  )
    return true
  if (typeof value === 'number' && isNaN(value)) return true
  if (typeof value === 'boolean' && !value) return true
  if (typeof value === 'object' && Object.keys(value).length === 0) return true
  return false
}
// status:购买状态0:未购 1:全部购买 3:部分购买(改为已购买)
// invalid:是否已作废:0-未作废,1-已作废,2-部分作废(改为已作废)
// expire:过期状态，0：未失效，1：已失效，2-部分失效(改为已失效)
// 已购买>已失效>已作废>已下单未支付>未购买 顺序
export function getStatusLabel({ status, expire, invalid }) {
  try {
    status = parseInt(status)
    expire = parseInt(expire)
    invalid = parseInt(invalid)
    const buy = {
      alt: '已购买',
      src: require('@/assets/img/work-place/buy-already.png'), //处方详情标签
      chatImage: require('@/assets/img/chat/p-buy-al.png') //im卡片标签
    }
    const expireAl = {
      alt: '已失效',
      src: require('@/assets/img/work-place/invalid-already.png'),
      chatImage: require('@/assets/img/chat/p-failure.png')
    }
    const invalidAl = {
      alt: '已作废',
      src: require('@/assets/img/work-place/voidv1.png'),
      chatImage: require('@/assets/img/chat/p-void.png')
    }
    const statusImgObj = {
      BUY: {
        0: {
          alt: '未购买',
          src: require('@/assets/img/work-place/buy-notv1.png'),
          chatImage: require('@/assets/img/chat/p-buy-not.png')
        },
        1: buy,
        2: {
          alt: '已下单未支付',
          src: require('@/assets/img/work-place/buy-notPay.png'),
          chatImage: require('@/assets/img/chat/p-buy-not.png')
        },
        3: buy
      },
      INVALID: {
        1: expireAl,
        2: expireAl
      },
      VOID: {
        1: invalidAl,
        2: invalidAl
      }
    }
    if ([1, 3].includes(status)) {
      return statusImgObj.BUY[status]
    } else {
      if ([1, 2].includes(expire)) {
        return statusImgObj.INVALID[expire]
      } else {
        if ([1, 2].includes(invalid)) {
          return statusImgObj.VOID[invalid]
        }
        return statusImgObj.BUY[status]
      }
    }
  } catch (error) {
    return
  }
}
// 就诊人取值处理()
export function getProfileByKey(data, key) {
  const { patientProfileName, age, gender } = data || {}
  const _age = age || age === 0 ? age + '岁' : ''
  const _gender = [0, 1].includes(gender) ? (gender === 0 ? '女' : '男') : ''
  switch (key) {
    case 'name':
      return patientProfileName || ''
    case 'age':
      return _age
    case 'gender':
      return _gender
    default:
      break
  }
}

// 处理问诊价格的显示
export function detailPrice(data, type) {
  const { times, charge, duration } = data || {}
  if (times && charge) {
    if (['phone', 'video'].includes(type)) {
      return `${charge}元/${duration}分钟`
    }
    return `${charge}元/${times + '' === '-1' ? '不限条数' : `${times}条`}/${duration}小时`
  } else {
    return '免费'
  }
}

export const maskPhoneNumber = phoneNumber => {
  // 确保输入是字符串并且长度为11
  if (typeof phoneNumber !== 'string' || phoneNumber.length !== 11) {
    // throw new Error('请输入有效的手机号')
    return '****'
  }
  // 使用正则表达式进行脱敏处理
  return phoneNumber.replace(/(\d{3})\d{4}(\d{4})/, '$1****$2')
}
/**
 * 姓名脱敏：保留首字，其余以单个 * 代替（已脱敏值幂等）
 * 空值返回 '--'
 */
export const maskName = name => {
  if (!name) return '--'
  const len = name.length
  // 1 字原样；2-3 字保留首字（如 张三→张*）；4 字及以上保留首尾、中间单个 *（如 欧阳铁柱→欧*柱）
  if (len <= 1) return name
  if (len <= 3) return `${name.charAt(0)}*`
  return `${name.charAt(0)}*${name.charAt(len - 1)}`
}
/**
 * 患者姓名按角色脱敏：仅当角色为患者（roleType 为 1 或 -1）时脱敏，
 * 其它角色（医生 / BD / 健管 / 运营 / 智能医助等）原样返回。已脱敏值幂等。
 */
export const maskPatientName = (name, roleType) => {
  const isPatient = roleType === 1 || roleType === -1
  return isPatient ? maskName(name) : name
}
export const scoreRange = n => {
  if (n <= 0) return []
  return Array.from({ length: n }, (_, index) => index + 1)
}
const getDateRange = date => {
  const arr = []
  arr[0] = moment(moment(date[0]).startOf('day').format('YYYY-MM-DD HH:mm:ss'))
  arr[1] = moment(moment(date[1]).endOf('day').format('YYYY-MM-DD HH:mm:ss'))
  return arr
}
// 获取时间范围快捷项
export const getMoment = mode => {
  let arrDate = []

  switch (mode) {
    case 1: // 今日
      arrDate = getDateRange([new Date(), new Date()])
      break
    case 2: //本月
      arrDate = getDateRange([moment().startOf('month'), moment().endOf('month')])
      break
    case 3: //上月
      arrDate = getDateRange([
        moment().subtract(1, 'month').startOf('month'),
        moment().subtract(1, 'month').endOf('month')
      ])
      break
    case 4: //近三月
      arrDate = getDateRange([moment().subtract(3, 'month'), moment()])
      break
    case 5: //近一个月
      arrDate = getDateRange([moment(new Date()).subtract(1, 'month'), moment()])
      break
    case 6: //近7天
      arrDate = getDateRange([moment().subtract(6, 'day'), moment()])
      break
    default:
      break
  }
  return arrDate
}

const DAY_IN_MS = 24 * 60 * 60 * 1000

const toStartOfDay = value => {
  const date = new Date(value)
  if (Number.isNaN(date.getTime())) return null
  return new Date(date.getFullYear(), date.getMonth(), date.getDate())
}

/**
 * 格式化用药结束时间，返回如 "3天后断药"、"2026-06-26"、"当日断药"、"已断药5天"
 * @param {Object} payload - 包含 medicationEndDateValue 的数据对象
 * @returns {string}
 */
export const formatMedicationEndTime = payload => {
  if (
    payload.medicationEndDateValue === null ||
    payload.medicationEndDateValue === undefined ||
    payload.medicationEndDateValue === ''
  ) {
    return '--'
  }
  const endDate = toStartOfDay(payload.medicationEndDateValue)
  if (!endDate) return '--'

  const today = toStartOfDay(new Date())
  if (!today) return '--'

  const dayDiff = Math.round((endDate.getTime() - today.getTime()) / DAY_IN_MS)
  if (dayDiff > 7) return moment(endDate).format('YYYY-MM-DD')
  if (dayDiff > 0) return `${dayDiff}天后断药`
  if (dayDiff === 0) return '当日断药'
  return `已断药${Math.abs(dayDiff)}天`
}
